/* eslint-disable jsx-a11y/anchor-is-valid */
import React,{ useState,useEffect } from "react"; 
import axios from 'axios';
import { ChangeMobileFormat } from "../../components/common/Common";

import closeIcon from '../../img/admin/icon_close.png';

const CallTo = ({phone,children}) => {
  return <a href={`tel:${phone}`} className="calling-btn">{children}</a>;
}

//둥지매물 신고를 위한 팝업창
const StaffCallNetwork = ({varOpenCallNetwork,setOpenCallNetwork}) => {

  const [varCallNetworkList1,setrCallNetworkList1] = useState([]);
  const [varCallNetworkList2,setrCallNetworkList2] = useState([]);

  const GetStaffCallingNetwork = async() => {
    await axios.post(`${process.env.REACT_APP_HOST}/_get_staff_call_network`).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //배차부
        const copyList1 = datas.results.filter(el=>el.st_department===2);
        setrCallNetworkList1(copyList1);
        //경리부
        const copyList2 = datas.results.filter(el=>el.st_department===1);
        setrCallNetworkList2(copyList2);
      }
    });    
  }

  //검색날짜가 변경시
  useEffect(() => {
    GetStaffCallingNetwork();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="poplayerCalling" style={varOpenCallNetwork?{display:"block"}:{display:"none"}}>
      <div className= "display-area">
        <div style={{fontSize:"20px",fontWeight:"600"}}>더나은물류 운영부 연락망</div>
        <div className="date-right-close"><img src={closeIcon} alt="" onClick={()=>setOpenCallNetwork(false)}/></div>
        <div className="consbox2 calling-body">
          <div className="pop-subject">배차부</div>
          <ul className="calling-list">
            {varCallNetworkList1.map((calling1,i)=>(
              <li key={'calling1_'+i} className="calling-line">
                <div style={{paddingTop:"8px"}}>
                  <span style={{fontSize:"16px"}}>{calling1.mem_name}&nbsp;{calling1.vp_name}</span>&nbsp;&nbsp;
                  <span style={{fontSize:"14px"}}>{ChangeMobileFormat(calling1.stc_mobile)}</span>
                </div>
                <CallTo phone={calling1.stc_mobile}>전화걸기</CallTo>
              </li>
            ))}
          </ul>
          <div className="pop-subject">경리부</div>
          <ul className="calling-list">
            {varCallNetworkList2.map((calling2,i)=>(
              <li key={'calling2_'+i} className="calling-line">
                <div style={{paddingTop:"8px"}}>
                  <span style={{fontSize:"16px"}}>{calling2.mem_name}&nbsp;{calling2.vp_name}</span>
                  <span style={{fontSize:"14px"}}>{ChangeMobileFormat(calling2.stc_mobile)}</span>
                </div>
                <CallTo phone={calling2.stc_mobile}>전화걸기</CallTo>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
export default StaffCallNetwork;